(function () {
  const U = window.TBX;
  const TB = window.TB;
  const cardEntry = U.cardEntry;
  const el = U.el;
  const entryKey = U.entryKey;
  const esc = U.esc;
  const fmtText = U.fmtText;
  const render = U.render;
  const setOf = U.setOf;
  const visibleCards = U.visibleCards;
  const renderCoverage = U.renderCoverage;
  const renderDetail = U.renderDetail;
  const renderHead = U.renderHead;
  const renderList = U.renderList;
  const renderRulesDrawer = U.renderRulesDrawer;
  const FAIL_REASONS = U.FAIL_REASONS;

  const scrollKeep = {};

  function saveScroll() {
    for (const id of ["tbrowsbox", "tbmainbox", "tbruleslistbox"]) {
      const e = document.getElementById(id);
      if (e) scrollKeep[id] = e.scrollTop;
    }
  }

  function restoreScroll() {
    for (const id in scrollKeep) {
      const e = document.getElementById(id);
      if (e) e.scrollTop = scrollKeep[id];
    }
  }

  TB.renderBench = function () {
    saveScroll();
    const root = document.getElementById("app");
    root.innerHTML = "";
    root.className = "";
    const wrap = el("div");
    wrap.id = "tbscreen";
    wrap.appendChild(renderHead());

    if (TB.online === false) {
      const off = el("div", "tboffline");
      off.appendChild(el("h2", "disp", "Server not running"));
      off.appendChild(el("div", null,
        "The testbench needs the local server so your verdicts persist to disk.<br><br>" +
        "<code>node sim/serve.js</code><br><br>" +
        "then open <code>http://localhost:8321/</code> and come back here."));
      const retry = el("button", "btn primary", "Retry");
      retry.onclick = function () { TB.open(); };
      off.appendChild(retry);
      wrap.appendChild(off);
      root.appendChild(wrap);
      return;
    }

    if (TB.status) wrap.appendChild(el("div", "tbstatus", esc(TB.status)));

    const body = el("div", "tbbody");
    if (TB.tab === "coverage") {
      body.appendChild(renderCoverage());
    } else if (!TB.loaded) {
      body.appendChild(el("div", "zlabel tbempty", TB.sets.length ? "Loading sets…" : "No set manifests yet — ask Claude to encode one."));
    } else {
      body.appendChild(renderList());
      body.appendChild(renderDetail());
    }
    wrap.appendChild(body);
    root.appendChild(wrap);
    const drawer = renderRulesDrawer();
    if (drawer) root.appendChild(drawer);
    restoreScroll();
  };

  TB.gameBar = function () {
    if (!TB.run) return null;
    const wrap = el("div");
    const bar = el("div");
    bar.id = "tbbar";
    wrap.appendChild(bar);
    const drawer = renderRulesDrawer();
    if (drawer) wrap.appendChild(drawer);
    const head = el("div", "tbbarhead");
    head.appendChild(el("span", "tbbarlabel", "TESTING"));
    head.appendChild(el("span", "tbbarname disp", esc(TB.run.name)));
    head.appendChild(el("span", "tbbarscen", esc(TB.run.scenario)));
    const rulesBtn = el("button", "btn tbbartoggle" + (TB.rules.open ? " primary" : ""), "Rules");
    rulesBtn.onclick = function () { TB.rules.open = !TB.rules.open; render(); };
    head.appendChild(rulesBtn);
    const toggle = el("button", "btn tbbartoggle", TB.barExpanded ? "▾" : "▸");
    toggle.onclick = function () { TB.barExpanded = !TB.barExpanded; render(); };
    head.appendChild(toggle);
    bar.appendChild(head);

    if (TB.barExpanded) {
      if (TB.run.expected) bar.appendChild(el("div", "tbbarexp", fmtText(TB.run.expected)));
      if (TB.canRecord) {
        const reasons = el("div", "tbreasons");
        for (const r of FAIL_REASONS) {
          (function (r) {
            const on = TB.barTags.indexOf(r.k) >= 0;
            const b = el("button", "tbreason" + (on ? " on" : ""), esc(r.label));
            b.title = r.hint;
            b.onclick = function () { TB.toggleBarTag(r.k); };
            reasons.appendChild(b);
          })(r);
        }
        bar.appendChild(reasons);
      }

      const row = el("div", "tbbarrow");
      if (TB.canRecord) {
        const note = document.createElement("input");
        note.type = "text";
        note.id = "tbbarnote";
        note.placeholder = "Note (what went wrong / observations)…";
        note.value = TB.barNote;
        note.oninput = function () { TB.barNote = note.value; };
        note.onkeydown = function (ev) { ev.stopPropagation(); };
        row.appendChild(note);
        for (const v of [["pass", "Pass"], ["fail", "Fail"]]) {
          (function (v) {
            const b = el("button", "btn tbv-" + v[0], v[1]);
            b.onclick = function () { TB.barVerdict(v[0]); };
            row.appendChild(b);
          })(v);
        }
      }
      const back = el("button", "btn", "Bench");
      back.title = TB.canRecord ? "Return without recording a verdict" : "Return to the bench";
      back.onclick = function () { TB.backToBench(); };
      row.appendChild(back);
      bar.appendChild(row);
    }
    return wrap;
  };

  document.addEventListener("keydown", function (ev) {
    if (APP.screen !== "testbench" || TB.tab !== "cards" || !TB.loaded) return;
    if (ev.target && (ev.target.tagName === "INPUT" || ev.target.tagName === "SELECT" || ev.target.tagName === "TEXTAREA")) return;
    const cards = visibleCards().filter(function (c) { return !TB.folds[setOf(c)]; });
    const idx = cards.findIndex(function (c) { return entryKey(c) === TB.sel; });
    const follow = function () {
      const e = document.getElementById("tbrowsel");
      if (e && e.scrollIntoView) e.scrollIntoView({ block: "nearest" });
    };
    const move = function (delta) {
      const next = Math.max(0, Math.min(cards.length - 1, idx + delta));
      if (next !== idx) { TB.sel = entryKey(cards[next]); render(); follow(); }
    };
    const vstep = TB.mode === "cards" ? 5 : 1;
    if (ev.key === "ArrowDown") {
      move(vstep);
      ev.preventDefault();
    } else if (ev.key === "ArrowUp") {
      move(-vstep);
      ev.preventDefault();
    } else if (ev.key === "ArrowRight" && TB.mode === "cards") {
      move(1);
      ev.preventDefault();
    } else if (ev.key === "ArrowLeft" && TB.mode === "cards") {
      move(-1);
      ev.preventDefault();
    } else if (ev.key === "Enter") {
      const entry = cardEntry(TB.sel);
      if (entry) {
        const sc = entry.scenario || { title: "Basic play", spec: {} };
        TB.launch(entry, sc);
      }
      ev.preventDefault();
    }
  });

})();
